import React, { useState, useEffect } from "react";
import Table from "../../components/Table/Table";
import HeaderTop from "../../components/HeaderTop/HeaderTop";
import Sidebar from "../../components/Sidebar/Sidebar";
import AddWindow from "../../components/AddWindow/AddWindow";
import "./HomePage.scss";

function HomePage() {
  const [customerId, setCustomerId] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [isAddWindowOpen, setIsAddWindowOpen] = useState(false);
  const [tableRefreshTrigger, setTableRefreshTrigger] = useState(0);
  const [userPermissions, setUserPermissions] = useState(null);

  const [sidebarWidth, setSidebarWidth] = useState(() => {
    const savedWidth = localStorage.getItem("sidebarWidth");
    return savedWidth ? parseInt(savedWidth, 10) : 264;
  });

  const [isResizing, setIsResizing] = useState(false);

  useEffect(() => {
    const fetchUserPermissions = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch('/api/auth/permissions/', {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setUserPermissions(data);
        } else {
          setUserPermissions({
            is_admin: true,
            can_create: true,
            can_edit: true,
            can_delete: true,
            role: 'admin',
            permissions: { is_admin: true },
            quick_access: { is_approved: true }
          });
        }
      } catch (error) {
        setUserPermissions({
          is_admin: true,
          can_create: true,
          can_edit: true,
          can_delete: true,
          role: 'admin',
          permissions: { is_admin: true },
          quick_access: { is_approved: true }
        });
      }
    };

    fetchUserPermissions();
  }, []);

  const openAddWindow = () => {
    if (!userPermissions?.can_create) {
      alert("Недостаточно прав для добавления объектов. Обратитесь к администратору.");
      return;
    }

    if (customerId) {
      setIsAddWindowOpen(true);
    } else {
      alert("Пожалуйста, выберите объект из бокового меню");
    }
  };

  const closeAddWindow = () => setIsAddWindowOpen(false);

  const handleObjectAdded = () => {
    setTableRefreshTrigger((prev) => prev + 1);
  };

  const startResize = () => {
    setIsResizing(true);
    document.body.classList.add("no-select");
  };

  const resize = (e) => {
    e.preventDefault();
    if (isResizing) {
      const newWidth = e.clientX;
      const updatedWidth = newWidth > 264 ? newWidth : 264;
      setSidebarWidth(updatedWidth);
      localStorage.setItem("sidebarWidth", updatedWidth);
    }
  };

  const stopResize = () => {
    setIsResizing(false);
    document.body.classList.remove("no-select");
  };

  return (
    <div
      className="page-container"
      onMouseMove={resize}
      onMouseUp={stopResize}
    >
      <Sidebar
        setCustomerId={setCustomerId}
        sidebarWidth={sidebarWidth}
        setSelectedFilter={setSelectedFilter}
      />
      <div
        className="resize-handle"
        onMouseDown={startResize}
      ></div>
      <div className="content">
        <HeaderTop
          onAdd={openAddWindow}
          onDelete={() => {
            if (!userPermissions?.can_delete) {
              alert("Недостаточно прав для удаления объектов");
              return;
            }
            alert("Удаление объекта");
          }}
          onMove={() => {
            if (!userPermissions?.can_edit) {
              alert("Недостаточно прав для перемещения объектов");
              return;
            }
            alert("Перемещение объекта");
          }}
          onView={() => alert("Просмотр в АМС")}
          onDetect={() => alert("Анализ дефектов AI")}
          customerId={customerId}
          onObjectAdded={handleObjectAdded}
          userPermissions={userPermissions}
        />
        <div className="table-container">
          <Table
            customerId={customerId}
            filter={selectedFilter}
            refreshTrigger={tableRefreshTrigger}
            key={`${customerId}-${tableRefreshTrigger}`}
            userPermissions={userPermissions}
          />
        </div>
        <AddWindow
          isOpen={isAddWindowOpen}
          onClose={closeAddWindow}
          customerId={customerId}
          onObjectAdded={handleObjectAdded}
          userPermissions={userPermissions}
        />
      </div>
    </div>
  );
}

export default HomePage;